import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CareGap`;

const getCareGapDetail = async (careGapId) => {
  try {
    const response = await axios.get(`${API_URL}/${careGapId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching care gap detail:", error);
    throw error;
  }
};

export default getCareGapDetail;
